<template>

<com-item name="players.count" :size="size" :is-empty="!active" :loading="loading" title="Player Count" :has-more="data.total > 5" v-on:more="onMoreClick">

	<template v-slot:about>

		<p>Breakdown of player counts and the players played with most.</p>

	</template>

	<template v-slot:stats>

		<div class="count">

			<div class="count-visual">

                <com-table :columns="['Count', 'Plays', 'Games', 'Players']" class="grid">

                    <com-row v-for="(item, index) in data.counts" :key="index" :is-selected="selected === item.value" :is-clickable="true" v-on:click="onCountClick(item.value)">

                        <com-cell type="text" :value="item.name" v-on:click="onClick(item.value)" />
                        <com-cell type="number" :value="item.plays" />
                        <com-cell type="number" :value="item.games" />
                        <com-cell type="number" :value="item.players" />

                    </com-row>

                </com-table>

			</div>

			<div class="count-list">

				<div class="count-loading"><i class="fa fa-spinner fa-spin" v-if="isLoadingPlayers" /></div>

				<div class="count-empty" v-if="!isLoadingPlayers && !data.players.length">No players.</div>

				<template v-if="!isLoadingPlayers && isRatio">

					<app-user type="player" :item="item" v-for="item in data.players" :subtext="item.count + ' plays'" count-field="ratio" count-percent="true" :key="'t' + item.key" />

				</template>

				<template v-if="!isLoadingPlayers && !isRatio">

					<app-user type="player" :item="item" v-for="item in data.players" :subtext="item.ratio + '% of their plays'" count-text="play" :key="'r' + item.key" />

				</template>

			</div>

        </div>

	</template>

	<template v-slot:buttons>

		<com-toggle :options="thresholdOptions" :value="thresholdValue" v-on:change="onThresholdChange" v-if="sortValue === 'ratio'" />

		<com-toggle :options="sortOptions" :value="sortValue" v-on:change="onSortChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comTable from './../common/Table'
import comCell from './../common/table/Cell'
import comRow from './../common/table/Row'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem,
		'com-table': comTable,
		'com-row': comRow,
		'com-cell': comCell,
		'com-toggle': comToggle
	},

	computed: {

		thresholdValue: function() {

			return this.$store.getters['filter/insights/players/count/threshold'] 

		},

		thresholdOptions: function() {

			var options = []

			options.push({value: 1, text: 'No minimum'})
			options.push({value: 2, text: 'Min. 2 plays'})
			options.push({value: 3, text: 'Min. 3 plays'})
			options.push({value: 4, text: 'Min. 4 plays'})
			options.push({value: 5, text: 'Min. 5 plays'})
			options.push({value: 10, text: 'Min. 10 plays'})
			options.push({value: 25, text: 'Min. 25 plays'})

			return options

		},

		isLoadingPlayers: function() {

			return this.fetching === 'count.band' || this.fetching === 'count.sort' || this.fetching === 'count.threshold'

		},

		isRatio: function() {

			return this.sortValue === 'ratio'

		},

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/players/counts']

		},

		active: function() {

			return this.data.counts.length && !this.loading

		},

		selected: function() {

			return this.$store.getters['filter/insights/players/count/band']

		},

		sortOptions: function() {

			var options = []

			options.push({value: 'total', text: 'Total plays'})
			options.push({value: 'ratio', text: 'Play ratio'})

			return options

		},

		sortValue: function() {

			return this.$store.getters['filter/insights/players/count/sort']

		}

	},

	methods: {

		onThresholdChange: function(value) {

			this.$store.commit('filter/insights/players/count/threshold', value)

		},

		onCountClick: function(value) {

			this.$store.commit('filter/insights/players/count/band', value)

		},

		onSortChange: function(value) {

			if(value == 'total') {

				this.$store.commit('filter/insights/players/count/threshold', 3)

			}

			this.$store.commit('filter/insights/players/count/sort', value)

		},

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersCount'
			})
		
		}

	}

}

</script>

<style scoped>

.grid {
	grid-template-rows: 40px 1fr 1fr 1fr 1fr 1fr;
}

.grid >>> .row {
	grid-template-columns: 25% 25% 25% 25%;
}

.grid >>> .row:not(.table-head) {
    border-bottom: 1px solid #f7f7f7;
}

.grid >>> .row:nth-child(even) {
	background-color: #fff;
}

.grid >>> .row:last-child{
	border: 0px;
}

.count {
	display: grid;
	grid-template-columns: 320px 1fr;
	height: 100%;
}

.count-list {
	border-left: 1px solid #eee;
}

.is-small-mobile .count {
	grid-template-columns: 1fr;
	grid-template-rows: 300px auto;
}

.is-small-mobile .count-list {
	border-left: 0px;
	border-top: 1px solid #eee;
}

.count-loading {
	position: absolute;
	width: 40px;
	height: 40px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.count-loading i {
	font-size: 24px;
	transform-origin: 50% 50%;
	color: #ffc563;
}

.count-empty {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 16px;
	font-weight: 400;
	color: #ccc;
}

</style>